// @ts-nocheck
class Tracker {
  static trackClick(data: any) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", { ...data });
    }
  }

  static trackLogin(idProvider: string) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "login", { method: idProvider });
    }
  }

  static trackDetailPageView(itemData: any) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "view_item", { ...itemData });
    }
  }

  static trackPreview(url: string) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", { custom_link_preview: url });
    }
  }

  static trackBuy(itemData: any) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "purchase", { ...itemData });
    }
  }
}
export default Tracker;
